module.exports = __webpack_public_path__ + "static/Resinbonded bridge-6d2548f2cc0cdd08f9b1f67772984864.jpg";